import { Directive, Input } from '@angular/core';
import { NgbRadioGroup } from '@mattlewis92/ng-bootstrap/buttons/radio';

@Directive({
    selector: '[ngbRadioGroup][value]'
})
export class NgbRadioGroupValueDirective {
    @Input() set value(value:boolean) {
        this.radio.writeValue(value);
    };
    
    constructor(private radio:NgbRadioGroup) {}
}


// WEBPACK FOOTER //
// ./web/static/services/directives/NgbRadioGroupValue.ts